import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	createProjectFailureTitleNonFinal: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createProjectFailureTitleNonFinalGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createProjectFailureDescriptionNonFinal: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	createProjectFailureTitleNonFinal: {
		id: 'cross-flow-onboarding-modal.create-project-failure-title',
		defaultMessage: 'Project not created',
		description: 'Title for the flag that appears when a project creation fails',
	},
	createProjectFailureTitleNonFinalGalaxia: {
		id: 'cross-flow-onboarding-modal.create-project-failure-title-galaxia',
		defaultMessage: 'Space not created',
		description: 'Title for the flag that appears when a project creation fails',
	},
	createProjectFailureDescriptionNonFinal: {
		id: 'cross-flow-onboarding-modal.create-project-failure-description',
		defaultMessage: "For some reason the magic didn't happen. Click get started to try again.",
		description: 'Description for the flag that appears when a project creation fails',
	},
});
export default messages;
